module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-winter-1900.62789066.svg";